import script from "./pay-forward-action-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./pay-forward-action-menu.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__